import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Card } from 'react-bootstrap';

const TotalAlumnos = ({ titleCard , number , iconClass }) => {
  return (
    <Card className="h-md-100">
      <Card.Header className="pb-0">
        <h6 className="mb-0 mt-2">{titleCard}</h6>
      </Card.Header>
      <Card.Body>
          <Badge pill bg="200" className="text-primary fs--2">
            <FontAwesomeIcon icon={iconClass} className="me-1" />
            {number}
          </Badge>
      </Card.Body>
    </Card>
  );
};
TotalAlumnos.propTypes = { 
  titleCard: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired, 
  iconClass: PropTypes.string,
};

export default TotalAlumnos;